import React from 'react';
import { Switch } from 'react-router';
import AppPaths from '../../AppPaths';
import SentryRoute from '../../SentryRoute';
import SeriesThreePlusSelection from './SeriesThreePlusSelection';
import { PurchaseSubscriptionContextProvider } from '../PurchaseSubscription/context/PurchaseSubscriptionContext';
import SeriesThreePlusComplete from './SeriesThreePlusComplete';
import { Series3UpgradeContextProvider } from '../../contexts/Series3UpgradeContext';
import UpgradeProductSelector from '../Upgrade/UpgradeProductSelector';
import UpgradeCart from '../Upgrade/UpgradeCart';
import Checkout from '../Checkout';

function withContext(Component: React.ComponentType) {
  return function WithContext() {
    return (
      <Series3UpgradeContextProvider>
        <Component />
      </Series3UpgradeContextProvider>
    );
  };
}

export default function Series3PlusUpgrade() {
  return (
    <PurchaseSubscriptionContextProvider>
      <Switch>
        <SentryRoute exact path={AppPaths.Series3PlusUpgrade.Complete()} component={SeriesThreePlusComplete} />
        <SentryRoute exact path={AppPaths.Series3PlusUpgrade.PlanSelection()} component={SeriesThreePlusSelection} />
        <SentryRoute>
          <Switch>
            <SentryRoute
              exact
              path={AppPaths.Series3PlusUpgrade.ProductSelector()}
              component={withContext(UpgradeProductSelector)}
            />
            <SentryRoute exact path={AppPaths.Series3PlusUpgrade.Bag} component={withContext(UpgradeCart)} />
            <SentryRoute path={AppPaths.Series3PlusUpgrade.Checkout} component={withContext(Checkout)} />
          </Switch>
        </SentryRoute>
      </Switch>
    </PurchaseSubscriptionContextProvider>
  );
}
